import { ArrivalAndDepartureInput } from '../../lib/types/models/arrival-and-departure/arrival-and-departure-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateArrivalAndDeparture(
  input: UpdateInput<ArrivalAndDepartureInput & { coachCompanyId?: number }>
) {
  const { id, ...data } = input
  return restApiClient.url(constructApiUrl(API.arrivalAndDeparture.update.url, { id })).patch(data)
}
